<!-- 报警内容 -->
<template>
    <div class="border " style="width: 300px;">
        <div class="pd-10" v-html="alarmContent">

        </div>

        <el-button class="w-100" type="primary" @click="alarmContentDetail">{{ $t('public.click_view_detail_abnormal') }}</el-button>
        <ExContentDetail></ExContentDetail>
    </div>
</template>

<script>
import ExContentDetail from '@/pages/applied/sysalarm/dialog/ExContentDetail.vue';
import bus from '@/utils/bus';
export default {
    props: ['model', 'index'],
    components: {
        ExContentDetail
    },
    computed: {
        alarmContent() {
            const content = this.model[this.index];
            return content.replaceAll('/n', '<br />')
        }
    },
    data() {
        return {

        }
    },
    methods: {
        alarmContentDetail() {
            bus.$emit('exContentDetail', { detail: this.model });
        }
    }
}
</script>

<style lang="scss" scoped></style>